import { zAddressDataSchema } from "../zAddressInfo";
import { zBaseCommonSchema } from "./base.common";
export const zBaseSchemaDom = zBaseCommonSchema.extend({
    addressInfo: zAddressDataSchema,
});
export const zBaseSchemaCreateDom = zBaseSchemaDom.omit({ id: true });
